import type { FaireProductEntity } from "../../entity_types/product";

export const p_9har3w5xpj: FaireProductEntity = {
  token: "p_9har3w5xpj",
  type: "product",
  name: "Smitten Kitten Ash Tray",
  brandToken: "b_b703e67f",
  brandName: "A Shop of Things",
  imageUrl:
    "https://cdn.faire.com/fastly/4393ae9fea461ff0c7f055c191eeb3452c16dc8f5736ed3e73d7133c930fd6bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0ad2a68dc5ebeec7e574a805fb98363b8cf02731c997fa8b1c6d738a50c5b8e.jpeg",
    "https://cdn.faire.com/fastly/caea6b8ef66b37b744060be3a8b292ab56559f458b346a252f60c18833990cdb.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "We're smitten with this cute little kitten!\n\nThis kitty wants to be your valentine! Featuring a little kitten sweetly holding a rose with a matching rose border, this is one of our cutest ash trays ever. Whether you smoke or you just want an adorable tray decorating your home, we're sure this cutie ash tray will do the trick! Perfect for pesky ashes or trinkets, choose your adventure! \n\n\nMeasures 5.5\" x 5.5\"\n\nTray does not come with accessories pictured.\n\nMade of steel covered tin.\n\nThis design is the sole property of A Shop of Things and cannot be reproduced or copied for any reason without permission beforehand. ©\n",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:34.470Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
